import { Auth, GoogleAuthProvider } from 'firebase/auth'
import { StyledFirebaseAuth } from 'react-firebaseui'
import { Grid, Typography, Divider, Paper } from '@mui/material'

import { useStyles } from './index.style'

const arcaneFeedMaxLogo = require('ressources/images/AI conic favicon.png')
const arcaneFavicon = require('ressources/images/arcaneFavicon.png')

interface SignInPageProps {
    firebaseAuth: Auth
}


const uiConfig = {
    signInFlow: 'popup',
    signInOptions: [
        GoogleAuthProvider.PROVIDER_ID
    ],
    callbacks: {
        // Avoid redirects after sign-in.
        signInSuccessWithAuthResult: () => false,
    },
}

const SignInPage = ({ firebaseAuth }: SignInPageProps) => {
    const classes = useStyles()
    return (
        <Grid container alignItems='center' classes={{ root: classes.root }}>
            <div className={classes.arcaneFaviconDiv}>
                <a href='https://www.arcane.run'>
                    <img src={arcaneFavicon} className={classes.arcaneFavicon} alt='arcaneLogo' />
                </a>
            </div>
            <div
                className={classes.illustrationSection}
            >
                 <Paper classes={{ root: classes.signInSection }} elevation={3}>
                        <img
                            src={arcaneFeedMaxLogo}
                            className={classes.smartfeedsLogo}
                            alt='smartfeeds_logo'
                        />
                        <Typography variant='h2'  className={classes.welcomeText}>
                            Welcome!
                        </Typography>
                            <StyledFirebaseAuth
                                uiConfig={uiConfig}
                                firebaseAuth={firebaseAuth}
                            />
                        <Divider className={classes.divider}/>
                        <div className={classes.contactUsDiv}>
                            <Typography>
                                Don&#39;t have an account yet ?
                            </Typography>
                            <Typography className={classes.secondaryTypography}>
                                <a
                                    className={classes.contactUsLink}
                                    href='https://www.arcane.run/en/contact-us'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    Contact us
                                </a>
                            </Typography>
                        </div>
                </Paper>
            </div>
        </Grid>
    )
}

export default SignInPage
